import React, {useRef, useState } from "react";
import RichTextEditor from "./RichTextEditor";
import { toast } from "react-toastify";
import {api} from "../utils/gashtaltAPI";
import { Input, useDisclosure } from "@chakra-ui/react";
import DeleteModal from "./DeleteModal";
import ImageViewer from "./ImageViewer";
import {
  MdBorderColor,
  MdDelete,
  MdOutlineAddCircle,
  MdOutlineImage,
  MdOutlineImageNotSupported,
  MdSave,
} from "react-icons/md";
import { FaGripHorizontal, FaGripVertical } from "react-icons/fa";

function AdminQuestionCard({
  deleteHandler,
  handler,
  id,
  examId,
  index,
  newQuestion = false,
  currentQuestionText = "",
  currentImage = null,
  currentShowUnder = false,
  currentOptions = [],
}) {
  const [editing, setEditing] = React.useState(newQuestion);
  const [options, setOptions] = React.useState(currentOptions);
  const [questionText, setQuestionText] = useState(currentQuestionText);
  const [image, setImage] = useState(currentImage);
  const [showUnder, setShowUnder] = useState(currentShowUnder);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedImage, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const triggerFileUpload = () => {
    fileInputRef.current.click();
  };
  const onFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    setImage(URL.createObjectURL(e.target.files[0]));
  };
  const addOption = (e) => {
    setOptions([
      ...options,
      {
        id: null,
        option: "",
        is_correct: false,
      },
    ]);
  };
  const onOptionChange = (index, event) => {
    const newValues = [...options];
    newValues[index].option = event.target.value;
    setOptions(newValues);
  };
  const handleOptionClick = (index) => {
    console.log(options);
    setOptions((prevOptions) =>
      prevOptions.map((option, i) => ({
        ...option,
        is_correct: i === index,
      }))
    );
  };
  const deleteOption = (index) => {
    setOptions((prevOptions) => prevOptions.filter((_, i) => i !== index));
  };
  const handleSubmit = async (e) => {
    if (questionText === "" || options.length < 2) {
      toast.error("حداقل 2 گزینه ضروری است!", {
        position: "bottom-right",
      });
      return;
    }
    try {
      const formData = new FormData();
      formData.append("exam_id", examId);
      formData.append("question_text", questionText);
      formData.append("show_under", showUnder === true ? "1" : "0");
      options.forEach((option, index) => {
        if (option.option === "") {
          toast.error("گزینه نمی تواند خالی باشد!", {
            position: "bottom-right",
          });
          throw new Error("گزینه ها نمیتوانند خالی باشند.");
        }
        formData.append(`options[${index}][id]`, option.id);

        formData.append(`options[${index}][option]`, option.option);
        formData.append(
          `options[${index}][is_correct]`,
          option.is_correct === true || option.is_correct===1 ? "1" : "0"
        );
      });
      if (selectedImage) formData.append("image", selectedImage);
      const response = await api.post(
        newQuestion ? `/api/question` : `/api/question/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const data = response.data;
      if (handler) handler(data.data);
      setEditing(false);
      toast.success(data.message, {
        position: "bottom-right",
      });
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status === 422 || status === 401) {
          toast.error(error.response.data.message, {
            position: "bottom-right",
          });
        }
      } else if (error.request) {
        toast.error("اتصال اینترنت خود را بررسی کنید!", {
          position: "bottom-right",
        });
      }
    }
  };
  const handleDelete = async (e) => {
    if (newQuestion) {
      deleteHandler();
      return;
    }
    try {
      const response = await api.get(`/api/question/delete/${id}`);
      toast.success(response.data.message, {
        position: "bottom-right",
      });
      deleteHandler();
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status === 422 || status === 401) {
          toast.error(error.response.data.message, {
            position: "bottom-right",
          });
        }
        return;
      } else if (error.request) {
        toast.error("اتصال اینترنت خود را بررسی کنید!", {
          position: "bottom-right",
        });
        return;
      }
      toast.error("خطایی رخ داد!", {
        position: "bottom-right",
      });
    }
  };
  return (
    <div>
      <div className="d-flex flex-row justify-content-end question-toolbar">
        <input
          type="file"
          ref={fileInputRef}
          onChange={onFileChange}
          style={{ display: "none" }}
          accept="image/*"
        />
        <MdDelete onClick={onOpen} className={"delete-icon"} />
        {editing ? (
          <>
            <div onClick={() => setShowUnder(!showUnder)}>
              {showUnder ? <FaGripHorizontal /> : <FaGripVertical />}
            </div>
            {image === null ? (
              <MdOutlineImage onClick={triggerFileUpload} />
            ) : (
              <MdOutlineImageNotSupported
                onClick={() => {
                  setImage(null);
                  setSelectedFile(null);
                }}
              />
            )}
            <MdSave className={"save"} onClick={handleSubmit} />
          </>
        ) : (
          <MdBorderColor
            onClick={() => {
              setEditing(true);
            }}
          />
        )}
      </div>
      <div className="question nazanin">
        {editing ? (
          <>
            <span>{index + 1}.</span>
            <div className={"text-center"}>
              <RichTextEditor
                value={questionText}
                setValue={(e) => {
                  setQuestionText(e);
                }}
              />
            </div>
          </>
        ) : (
          <div className="d-flex flex-row">
            <span className="me-3 bold">{index + 1})</span>
            <div className="d-flex flex-column flex-fill  col-12">
            <div
            dangerouslySetInnerHTML={{
              __html: `${questionText}`,
            }}
            className={"text flex-fill"}
          ></div>
          <div className="row justify-content-between col-12" dir={"ltr"}>
          {image !== null && (
            <ImageViewer src={image} alt={"تصویر"} className={"col-lg-6"} />
          )}
          <ul
            className={`ps-0 ${image ? "col-lg-6" : "col-12"} ${
              showUnder ? "d-flex flex-row justify-content-start option-lined" : ""
            }`}
            dir={"rtl"}
          >
          {options.map((option, index) => (
                  <li
                    key={option.id}
                    className={`align-items-start ${option.is_correct ? "selected correct-answer" : ""}`}
                  >
                    <span className="counter">
                      <div>{index + 1}</div>
                    </span>
                    {option.option}
                  </li>
                ))}
                </ul>
          </div>
              </div>

            </div>
        )}
        { editing && (<><div className="row justify-content-end" dir={"ltr"}>
          {image !== null && (
            <ImageViewer src={image} alt={"تصویر"} className={"col-lg-6"} />
          )}
          <ul
            className={`${image ? "col-lg-6" : "col-12"} ${
              showUnder ? "d-flex flex-row justify-content-start option-lined" : ""
            }`}
            dir={"rtl"}
          >
            
              <>
                <li key={0} onClick={addOption}>
                  <span className="counter">
                    <div>
                      <MdOutlineAddCircle />
                    </div>
                  </span>
                  افزودن گزینه
                </li>
                {options.map((option, index) => (
                  <li
                    key={option.id}
                    className={
                      option.is_correct ? "selected correct-answer" : ""
                    }
                  >
                    <span
                      className={`counter`}
                      onClick={() => {
                        handleOptionClick(index);
                      }}
                    >
                      <div>{index + 1}</div>
                    </span>
                    <Input
                      value={option.option}
                      onChange={(event) => {
                        onOptionChange(index, event);
                      }}
                    />
                    <MdDelete
                      onClick={() => {
                        deleteOption(index);
                      }}
                      className={"delete-icon"}
                    />
                  </li>
                ))}
              </>
          </ul>
        </div>
        </>)}
      </div>
      <DeleteModal onClose={onClose} isOpen={isOpen} Delete={handleDelete} />
    </div>
  );
}

export default AdminQuestionCard;
